import { useHead } from '@vueuse/head'
import { computed } from 'vue'

import { useTradingPageStore } from '@/stores/tradingComponents'

export const fetchTemplateOneStore = async (slug: string, template?: string) => {
  const tradingStore = useTradingPageStore()

  await tradingStore.fetchTradingPageTypeOneComponents(slug, template)
}

export const useTemplateOneData = () => {
  const tradingStore = useTradingPageStore()
  return computed(() => tradingStore.getTradingPageData)
}

export const useTemplateOneTradingSeo = () => {
  useHead({
    title: useTemplateOneTradingSeoTitle(),
    meta: [
      {
        name: 'description',
        content: useTemplateOneTradingSeoDescription()
      },
      {
        property: 'og:title',
        content: useTemplateOneTradingSeoTitle()
      },
      {
        property: 'og:description',
        content: useTemplateOneTradingSeoDescription()
      }
    ]
  })
}

export const useTemplateOneTradingSeoTitle = () => {
  const tradingStore = useTradingPageStore()
  return computed(() => {
    if (tradingStore.getTradingPageData?.fields?.seo_page?.title) {
      return tradingStore.getTradingPageData.fields.seo_page.title
    }
    return 'Default Title'
  })
}

export const useTemplateOneTradingSeoDescription = () => {
  const tradingStore = useTradingPageStore()
  return computed(() => {
    if (tradingStore.getTradingPageData?.fields?.seo_page?.description) {
      return tradingStore.getTradingPageData.fields.seo_page.description
    }
    return 'Default Description'
  })
}

// TODO move unsubscribe to new service with preferences too as well as repo and store!!
export const useSeoIndexFollowUnsubscribe = (): boolean => {
  const tradingStore = useTradingPageStore()
  return tradingStore.getTradingPageData?.fields?.seo[0]?.fields?.noindexnofollow === true
}
export const useSeoIndexFollowUnsubscribePreferences = (): boolean => {
  const tradingStore = useTradingPageStore()
  return tradingStore.getTradingPageData?.fields?.seo[0]?.fields?.noindexnofollow === true
}
